import { OrderState } from "@/enums";

export const showShippingOrderTopics = ["cancellation", "request-refund"];

/**
 * topic 상태별 hidden 처리.
 *
 * ⚠️ **`cancellation` 에서 배송 후 주문을 막지 않는다** (#5175).
 *
 * 종전에는 `Delivered` 를 숨기고 `Shipped` 를 비활성으로 뒀는데, 그 조합에서 EU 고객이
 * "Cancellation" 을 고르면 선택할 주문이 하나도 없어 **"철회가 막혔다"** 로 읽혔다. EU
 * 소비자는 수령 후에도 철회권(CRD Art. 9(2)(b) — 수령일 + 14일)을 보유하므로 그 표시는
 * 사실과 다르다. 온라인 접수 경로(#5175)가 생긴 뒤에도 이 폼은 **대체 경로**로 남아야
 * 한다 — Art. 11a 는 철회 수단의 상시 제공을 요구한다.
 *
 * ⚠️ **`returnRequested` 도 숨기지 않는다.** 종전에는 두 topic 모두에서 숨겼는데, 반품
 * 되돌리기가 서버 409(`return-processing-started` = CS 착수, `no-active-return-request`
 * = admin·마켓플레이스가 만든 상태)로 막히면 **주문 상세에도 지원센터에도 창구가 없는
 * 교착**이 생겼다. 주문이 하나뿐인 고객은 "No ordered items" 만 본다.
 *
 * 실제로 숨기는 것은 `orderCancelled` 뿐이다 — 이미 종결돼 접수할 것이 없다.
 */
export const hiddenOrderByTopics = {
  cancellation: [OrderState.OrderCancelled],
  "request-refund": [
    OrderState.OrderPlaced,
    OrderState.Packing,
    OrderState.OrderCancelled,
  ],
};

/**
 * 클릭 자체를 막는 상태. **현재는 비어 있다.**
 *
 * ⚠️ 여기에 상태를 넣으면 `ShippingOrderItem` 이 `pointer-events-none` + 흐림 처리를
 * 하므로, 법정 접수 경로를 UI 로 막는 셈이 된다. 배송 후 주문을 "보이되 기본 선택은
 * 하지 않는" 목적이라면 아래 `autoSelectExcludedOrderByTopics` 를 쓸 것.
 */
export const disabledOrderByTopics = {
  cancellation: [],
  "request-refund": [],
};

/**
 * 표시는 하되 **초기 자동 선택에서 제외**할 상태.
 *
 * ⚠️ 이 목록이 따로 있는 이유가 중요하다. `ShippingOrderWrap` 의 초기 선택이 종전에는
 * hidden·disabled 목록에서 **파생**됐다. 그래서 위에서 배송 후 주문의 hidden/disabled 를
 * 걷어내자 **과거 배송완료 주문 전부가 자동 선택**돼, 고객이 고르지 않은 주문까지 CS
 * 취소 요청 메일에 실려 나가는 경로가 생겼다(2년 전 주문 포함). 표시 정책과 선택 정책은
 * 목적이 다르므로 분리한다.
 *
 * 고객이 직접 클릭해 고르는 것은 그대로 가능하다 — 막는 게 아니라 **기본값을 비우는** 것이다.
 */
export const autoSelectExcludedOrderByTopics = {
  cancellation: [
    OrderState.Shipped,
    OrderState.Delivered,
    OrderState.ReturnRequested,
  ],
  "request-refund": [OrderState.ReturnRequested],
};

/**
 * "Already Shipped" 배지 대상.
 *
 * 종전에는 배지가 `disabled` 여부에 묶여 있어서, disabled 를 걷어내면 **배송 후라는
 * 표시까지 함께 사라졌다.** 배지는 사실 고지이므로 선택 가능 여부와 독립이어야 한다.
 */
export const POST_SHIPMENT_STATES: OrderState[] = [
  OrderState.Shipped,
  OrderState.Delivered,
  OrderState.ReturnRequested,
];
